import { CreditCardType } from "@/constants/CreditCardType";

export interface PaymentIcon {
  name: string;
  shortName?: string;
  src: string;
}

export const CARD_BRAND_ICONS: PaymentIcon[] = [
  { name: CreditCardType.VISA, src: "/images/visa.svg" },
  { name: CreditCardType.MASTERCARD, src: "/images/mastercard.svg" },
  { name: CreditCardType.AMEX, shortName: "Amex", src: "/images/amex.svg" },
  { name: CreditCardType.DISCOVER, src: "/images/discover.svg" },
];

export const PAYPAL_ICON: PaymentIcon = { name: "PayPal", src: "/images/paypal.svg" };

function normalizeBrand(brand: string) {
  return brand.toLowerCase().replace(/[\s_-]/g, "");
}

export function getCardBrandIcon(cardType: string): PaymentIcon | undefined {
  const key = normalizeBrand(cardType);
  return CARD_BRAND_ICONS.find(icon => normalizeBrand(icon.name) === key);
}

// Display name for a backend brand, e.g. "AmericanExpress" → "American Express". Unknown brands pass through.
export function formatCardBrand(cardType: string): string {
  return getCardBrandIcon(cardType)?.name ?? cardType;
}

// Display short name for small UI elements, e.g., "Amex" instead of "American Express"
export function formatCardBrandShort(cardType: string): string {
  const icon = getCardBrandIcon(cardType);
  return icon?.shortName ?? icon?.name ?? cardType;
}
